<template>
  <div class="swiper-banner">
    <div class="swiper-wrapper">
      <div class="swiper-slide" v-for="li in bannerList" :key="li.id">
        <img :src="li.img" ref="bannerimg" @click="goLook(li)" />
      </div>
    </div>
    <div class="swiper-pagination"></div>
  </div>
</template>
<script>
import Swiper from "swiper";

export default {
  name: "SwiperBanner",
  data() {
    return {
      activeIndex: 0,
      bannerList: [],
      mySwiper: null,
    };
  },
  mounted() {
    this.getBannerList().then(() => {
      if (!this.mySwiper) {
        this.installSwiper();
      }
    });
  },
  activated() {
    this.getBannerList().then(() => {
      if (!this.mySwiper) {
        this.installSwiper();
      }
    });
  },
  methods: {
    goLook(liHref) {
      if (liHref.is_outside_url === 1 && !liHref.url.includes("?")) {
        window.location.href = `${liHref.url}?user_id=${
          localStorage._user_data_id
        }&department_id=${localStorage._user_data_department_id}&company_id=${
          localStorage._user_data_company_id
        }&sso_token=${localStorage._user_data_sso_token}&client_version=${
          localStorage.client_version || "1.2.0"
        }&sys_id=${localStorage._sys_id || "5"}`;
      } else if (liHref.is_outside_url === 1 && liHref.url.includes("?")) {
        window.location.href = `${liHref.url}&user_id=${
          localStorage._user_data_id
        }&department_id=${localStorage._user_data_department_id}&company_id=${
          localStorage._user_data_company_id
        }&sso_token=${localStorage._user_data_sso_token}&client_version=${
          localStorage.client_version || "1.2.0"
        }&sys_id=${localStorage._sys_id || "5"}`;
      } else if (liHref.url.includes("samples.eceibs.com.cn")) {
        window.location.href = liHref.url + "is_webview=0";
      } else {
        this.$router.push({
          path: "./banner_detail",
          query: { banner_id: liHref.id },
        });
      }
    },
    installSwiper() {
      this.mySwiper = new Swiper(".swiper-banner", {
        loop: true,
        speed: 1000,
        autoplay: {
          delay: 2000,
          stopOnLastSlide: false,
          disableOnInteraction: false, // swiper手动滑动后自动轮播失效
        },
        observer: true,
        observeParents: true,
        autoplayDisableOnInteraction: false,
        // 如果需要分页器
        pagination: { el: ".swiper-pagination" },
      });
    },
    getBannerList() {
      let url = "index.php/mobile/index/banner-list";
      let params = {
        user_id: localStorage.getItem("_user_data_id"),
        company_id: localStorage.getItem("_user_data_company_id"),
        sso_token: localStorage.getItem("_user_data_sso_token"),
        sys_id: localStorage.getItem("_sys_id"),
        language: localStorage.getItem("_user_data_language"),
        size: 8,
      };
      return new Promise((resolve) => {
        this.$axios.post(url, params).then((res) => {
          if (res.data.code == 0) {
            this.bannerList = res.data.result.list;
          }
          resolve();
        });
      });
    },
  },
};
</script>

<style scoped lang="less">
@import "~swiper/css/swiper.min.css";

.swiper-banner {
  width: 100%;
  position: relative;
  overflow-x: hidden;
  .swiper-pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    /deep/ .swiper-pagination-bullet {
      width: 0.1rem;
      height: 0.1rem;
      background: rgba(255, 255, 255, 0.4);
      border-radius: 50%;
      margin: 0 0.1rem;
      transition: all 0.25s;
    }
    /deep/ .swiper-pagination-bullet-active {
      width: 0.14rem;
      height: 0.14rem;
      background: rgba(255, 255, 255, 0.8);
    }
  }
}
.swiper-slide {
  width: 100%;
  position: relative;
  height: 3.52rem;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>
